import get from 'lodash.get';
import { emptyObject } from 'ui-components/default-props/empty';

export const selectExportShipmentJobByJobId = (state, { jobId }) => {
  const jobIdToJobMap = get(state, 'jobIdToJobMap', emptyObject);
  return jobIdToJobMap[jobId];
};
